import React, { useEffect, useState } from 'react';
import { Input, Button, Divider, Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import { FiPlusCircle } from "react-icons/fi";
import { useNavigate } from 'react-router-dom';
import { deleteDataRequest, getDataRequest, postDataRequest } from '../../api/serviceMethods';
import { COURSE_CATEGORY_URL, TAGS_URL } from '../../api/URLs';
import TagMagazineModal from '../../components/magazine/TagMagazineModal';
import CourseCategoryModal from '../../components/magazine/CourseCategoryModal';
import SearchSvg from '../../assets/images/SearchSvg';

const EducationCourseHeader = ({
    setViewType, setModalOpen,
    modalOpen, dates, setDates,
    loading, setTableParams, setLoading,
    tableParams, initLoadMagazine,
    setKeyword, keyword, messageModalRef
}) => {
    const [isListView, setIsListView] = useState(true);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [newTag, setNewTag] = useState("");
    const [tags, setTags] = useState([]);
    const [loadingNew, setLoadingNew] = useState(false);

    const getDataRequestAll = async (value) => {
        setLoading(true)
        await getDataRequest(`${COURSE_CATEGORY_URL}`, {
            // pageNo: tableParams.pagination.current,
            // pageSize: tableParams.pagination.pageSize,
        }).then((res) => {
            if (res.status === 200) {
                let datas = res?.data ? res?.data.map((it, i) => ({
                    ...it,
                    name: it.name || "",
                })) : []
                setTags(datas);
            }
            // setTableParams({
            //     ...tableParams,
            //     pagination: {
            //         ...tableParams.pagination,
            //         total: res.total,
            //     },
            // });
            setLoading(false);
        }).catch((err) => {
            setLoading(false)
            console.log("Error", err)
        });
    }
    useEffect(() => {
        getDataRequestAll()
    }, [modalOpen])

    const handleCreate = async (name) => {
        try {
            setLoadingNew(true);
            await postDataRequest(`${COURSE_CATEGORY_URL}`, { name: name })
                .then((res) => {
                    if (res.status === 200) {
                        setNewTag("");
                        messageModalRef.current.showSuccessConfirmsAutoClose(t(res && t(res.message)), () => { }, "", true);
                        getDataRequestAll('');
                        setTimeout(() => {
                            setLoading(false);
                        }, 2000);
                    } else {
                        messageModalRef.current.showWarningConfirmsAutoClose(res && t(res.message), () => { }, "", true);
                    }
                    setLoadingNew(false);
                })
                .catch((err) => {
                    setLoadingNew(false);
                    messageModalRef.current.showWarningConfirmsAutoClose(err && err.response && err.response.data && err.response.data.message || "Server Error!", () => { }, "", true);
                });
        } catch (error) {
            setLoadingNew(false)
            messageModalRef.current.showWarningConfirmsAutoClose(t(`Server Error!`), () => { }, "", true);
        }
    }

    const handleAddTag = () => {
        if (newTag.trim() !== "") {
            let filterData = tags.filter(it => it.name === newTag.trim())
            if (filterData.length > 0) {
                messageModalRef.current.showWarningConfirmsAutoClose(t('The tag has exited!'), () => { }, "", true);
                return false
            }
            handleCreate(newTag.trim())
        }
    };

    const handleDeleteTag = (tag, i) => {
        if (tag._id) {
            messageModalRef.current.showWarningConfirm(t('Are you sure you want to delete this course category?'), async () => {
                setLoadingNew(true)
                await deleteDataRequest(`${COURSE_CATEGORY_URL}/${tag._id}`).then((res) => {
                    messageModalRef.current.showSuccessConfirmsAutoClose(res && t(res.message), () => { }, "", true);
                    getDataRequestAll('');
                    setLoadingNew(false)
                }).catch((err) => {
                    messageModalRef.current.showWarningConfirmsAutoClose(t(`Server Error!`), () => { }, "", true);
                    setLoadingNew(false)
                });
            }, "", true);
        } else {
            setTags(tags.filter((t) => t !== tag));
        }
    };

    return (
        <>
            <Row className='d-flex align-items-center mt-4'>
                <Col md={15}
                    style={{ display: 'flex', justifyContent: "space-between" }}
                >
                    <Input
                        placeholder={t("Search")}
                        prefix={<SearchSvg style={{ color: '#8c8c8c' }} />}
                        style={{ width: "40%" }}
                        size="large"
                        disabled={loading}
                        loading={loading}
                        className="me-4"
                        allowClear
                        value={keyword}
                        onChange={(e) => setKeyword(e.target.value)}
                    />
                </Col>
                <Col md={9} style={{ display: 'flex', alignItems: 'center', justifyContent: "space-between" }}>
                    <Button
                        size="large"
                        onClick={() => {
                            setTableParams({
                                ...tableParams,
                                pagination: {
                                    ...tableParams.pagination,
                                    current: 1,
                                },
                            });
                            initLoadMagazine();
                        }}
                    >
                        {t('Query')}
                    </Button>
                    <Divider type="vertical" style={{ height: '24px', borderColor: '#d9d9d9' }} />
                    <div className='d-flex align-items-center'>
                        <Button
                            className=''
                            type="text"
                            onClick={() => setModalOpen(true)}
                            style={{
                                fontSize: '16px',
                                marginRight: "1rem",
                                color: "#e72158",
                                border: "1px solid #e72158"
                            }}
                        >
                            {t('Course Category')}
                        </Button>
                        <Button
                            icon={<FiPlusCircle />}
                            onClick={() => navigate("/education-teacher/upload")}
                            style={{
                                fontSize: '16px',
                                backgroundColor: "#F8E2E8",
                                border: "none",
                                color: "#E50A47"
                            }}
                            danger
                        >
                            {t('Create teacher')}
                        </Button>
                    </div>
                </Col>
            </Row>
            <CourseCategoryModal
                setModalOpen={setModalOpen}
                modalOpen={modalOpen}
                setTags={setTags}
                setNewTag={setNewTag}
                handleAddTag={handleAddTag}
                tags={tags}
                handleDeleteTag={handleDeleteTag}
                loadingNew={loadingNew}
                setLoadingNew={setLoadingNew}
                newTag={newTag}
            />
        </>
    );
};

export default EducationCourseHeader;
